import { useAuth0 } from '@brighte/passwordless-authenticator';
import { ApplicationFormStatus } from '@graphql/index';
import { ApplicationSubmissionStatus } from '@pages/ApplicationStatus/types';
import { useApplicationData } from '@provider';
import { APPLICATION_FORM, REFERRED, isJointApplicant } from '@utils';
import { getCongratulationMessage, getSubmittedPageTitle } from './helpers';

export const useGetPageTitle = (status?: ApplicationSubmissionStatus) => {
  const {
    HouseholdDetails: householdDetails,
    SubmitApplication: submitApplication,
    quote,
  } = useApplicationData(['HouseholdDetails', 'SubmitApplication', 'quote']);

  const isSubmitted = submitApplication?.status === ApplicationFormStatus.Submitted;
  const isJointForm = isJointApplicant();
  const hasJoint = !!householdDetails?.hasJointApplicant;
  const { user } = useAuth0();

  const renderTitle = () => {
    if (status === ApplicationSubmissionStatus.APPROVED) {
      return getCongratulationMessage(user);
    }

    if (status === ApplicationSubmissionStatus.REFERRED) {
      return REFERRED.PAGE_TITLE;
    }

    if (isSubmitted) {
      return getSubmittedPageTitle(hasJoint, isJointForm);
    }

    const financialProductName = quote?.financialProduct?.name ?? '';

    const applicationFormName = APPLICATION_FORM(financialProductName);

    return applicationFormName[quote?.financialProduct?.id ?? ''] ?? financialProductName;
  };

  return renderTitle();
};
